var map = {
	"./arrow-up.svg": 98770,
	"./arrow.svg": 95719,
	"./bid.svg": 41937,
	"./boxes.svg": 73660,
	"./caret-up.svg": 34651,
	"./claim.svg": 95748,
	"./collateral.svg": 87039,
	"./connectors/arrow-right.svg": 90452,
	"./connectors/coinbaseWalletIcon.svg": 65,
	"./connectors/metamask-fox.svg": 49496,
	"./connectors/walletConnectIcon.svg": 92826,
	"./cookie.svg": 23403,
	"./curve.svg": 98775,
	"./dark-arrow.svg": 11011,
	"./debt.svg": 83572,
	"./error.svg": 98498,
	"./eth-img.svg": 48080,
	"./flx-logo.svg": 23504,
	"./flx_uni_eth.svg": 61322,
	"./flx_uni_hai.svg": 84037,
	"./incentive.svg": 99158,
	"./mine.svg": 63709,
	"./od-full-logo.svg": 56860,
	"./od-logo.svg": 96721,
	"./op-img.svg": 262,
	"./plus.svg": 26164,
	"./sell-od.svg": 34952,
	"./siren.svg": 13431,
	"./splash/discord.svg": 77190,
	"./splash/eth.svg": 7060,
	"./splash/liquid-eth.svg": 9068,
	"./splash/optimism.svg": 29255,
	"./splash/partly-cloudy.svg": 16321,
	"./splash/twitter.svg": 11695,
	"./stFLX.svg": 49152,
	"./staking.svg": 37488,
	"./surplus.svg": 23390,
	"./uniswap-icon.svg": 53461,
	"./wbtc-img.svg": 72532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40968;